/*
 * @Author: YuanYuan
 * @Date: 2024-02-07 10:39:33
 * @LastEditTime: 2025-08-25 17:00:41
 * @description: 流量分析路由定义
 */
import i18n from '@/i18n'

export default [
  {
    path: '/trafficAnalysis',
    meta: {
      title: i18n.t('menu.trafficAnalysis'),
      leftMenuCode: 'Configurations',
    },
    component: () => import('@/views/trafficAnalysis/index.vue')
  }
]